<script setup lang="ts">
</script>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
    name: 'PaymentResult',

    data(): {
        isWarningClosed: boolean
    } {
        return {
            isWarningClosed: false,
        }
    },

    computed: {
        isWarningVisible(): boolean
        {
            return (this.$route.query.success !== undefined
                || this.$route.query.error !== undefined)
                && !this.isWarningClosed
        },
    },
})
</script>

<template>
    <Transition name="result-fade">
        <div class="result absolute-fill" v-if="isWarningVisible">
            <div class="bg absolute-fill" @click="this.isWarningClosed = true"/>

            <div class="content">
                <i class="bi bi-x-lg" @click="this.isWarningClosed = true"/>

                <template v-if="this.$route.query.success !== undefined">
                    <p>
                        Поздравляем с приобретением пропуска!
                    </p>
                    <p>
                        Информация о заказе отправлена на e-mail.
                    </p>
                    <p>
                        Большое спасибо за поддержку проекта!
                    </p>
                </template>

                <template v-else-if="this.$route.query.error !== undefined">
                    <p>
                        Похоже, произошла какая-то ошибка при оплате.
                    </p>
                    <p>
                        Попробуем ещё раз?
                    </p>
                </template>
            </div>
        </div>
    </Transition>
</template>

<style scoped lang="scss">
.result-fade-enter-active {
    transition: opacity 0.5s ease;
}
.result-fade-leave-active {
    transition: opacity 1s ease;
}

.result-fade-enter-from,
.result-fade-leave-to {
    opacity: 0;
}

.result {
    position: fixed;
    z-index: 99900;
    display: flex;
    justify-content: center;
    align-items: center;
}

.bg {
    background: rgba(0, 0, 0, 0.7);
    z-index: 100;
}

.bi {
    position: absolute;
    top: 0;
    right: 0;
    color: gray;
    font-size: 20px;
    padding: 5px 8px 5px 8px;
    cursor: pointer;

    &:hover {
        color: whitesmoke;
    }
}

.content {
    position: relative;
    z-index: 200;
    background: rgba(0, 0, 0, 0.9);
    border: 1px solid rgba(255, 255, 255, 0.2);
    border-radius: 8px;
    padding: 30px;
    font-size: 15px;
    color: white;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

p {
    margin: 5px;
}
</style>
